import React from 'react';
import { View } from 'react-native';
import { CodeField } from 'react-native-confirmation-code-field';
import { useAutoFocusInput } from 'hooks/useAutoFocusInput';
import Color from 'color';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
import Indicator from './Indicator';
import Text from './Text';
import { rem } from './values';
const PhoneVerificationCodeInputView = ({ fieldRef, value, onChangeText, fetching, }) => {
    useAutoFocusInput(fieldRef);
    const styles = useStyles(styleSet);
    return (<View style={styles.container}>
      <CodeField ref={fieldRef} cellCount={6} value={value} onChangeText={onChangeText} renderCell={({ symbol, index }) => (<View style={styles.cellContainer} key={index.toString()}>
            {symbol ? (<Text Numbers-24 OffBlack>
                {symbol}
              </Text>) : (<View style={styles.emptyCell}/>)}
          </View>)} keyboardType="number-pad" textContentType="oneTimeCode" testID="codeField"/>
      {fetching ? <Indicator style={styles.indicator} dark/> : null}
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    container: {
        flex: 1,
        margin: 20,
        justifyContent: 'center',
        alignItems: 'center',
    },
    indicator: {
        position: 'absolute',
        alignSelf: 'center',
        paddingTop: rem(100),
    },
    cellContainer: {
        margin: rem(16),
        minWidth: rem(16),
        justifyContent: 'center',
        alignItems: 'center',
    },
    emptyCell: {
        alignSelf: 'center',
        borderRadius: rem(12),
        backgroundColor: Color(colors.text.brand).fade(0.8).toString(),
        width: rem(12),
        height: rem(12),
    },
}));
export default PhoneVerificationCodeInputView;
